// extracted by mini-css-extract-plugin
export default {"fullWidth":"pp-z","image":"qp-z","lazyLoadPicture":"rp-z","lazyLoadSpinner":"sp-z","lazyLoadSpin":"tp-z","lazyLoadImage":"up-z","hasStyledAspectRatio":"vp-z"};